import useTranslator from "../../hooks/useTranslator";
import AnalysisLoading from "../AnalysisLoading/AnalysisLoading";

const DocumentAnalysisLoadingPopup = ({
  showPopup,
  isGuarantor,
  documentCount,
}) => {
  const { _t } = useTranslator();

  const count =
    typeof documentCount === "number" && Number.isFinite(documentCount)
      ? documentCount
      : null;

  const title =
    count !== null && count > 0
      ? _t(
          "analyzingYourDocumentsCount",
          count === 1
            ? "Analyzing your 1 document"
            : `Analyzing your ${count} documents`,
          { count }
        )
      : _t("analyzingYourDocuments", "Analyzing your documents");

  return (
    <AnalysisLoading
      show={showPopup}
      mode="modal"
      isGuarantor={isGuarantor}
      title={title}
      subtitle={_t(
        "analyzingDocumentsSubtitle",
        "A few seconds. Don't close this window."
      )}
      steps={[
        _t("readingYourFiles", "Reading your files"),
        _t("checkingForDuplicates", "Checking for duplicates"),
        _t("verifyingDocumentsAreYours", "Verifying the documents are yours"),
      ]}
      footer={_t("dataTravelsEncrypted", "Data travels encrypted")}
    />
  );
};

export default DocumentAnalysisLoadingPopup;
